"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RainHeavy = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const RainHeavy = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "rain-heavy", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "rain-heavy", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M8 20a8 8 0 1 0 16 0c0-2.945-2.667-8.279-8-16-5.333 7.721-8 13.055-8 16Zm8-12.427A97.366 97.366 0 0 1 18.164 11h-4.328A97.366 97.366 0 0 1 16 7.573Z", fill: "#324CA8", fillRule: "evenodd" }) })) })));
};
exports.RainHeavy = RainHeavy;
